import Components, { JitsiComponents } from "../../../components";

import ProcessVariableApi from "../../../service/ProcessVariableService";
import DocumentApi from "../../../service/DocumentService";

import FaceRecognitionApi from "../../../service/FaceRecognitionService";
import VideoCallCompleteProvisionApi from "../../../service/VideoCallCompleteProvisionService";
import CalculateFaceRecognitionRequest from "../../../service/request/CalculateFaceRecognitionRequest";
import SetProcessVariablesRequest from "../../../service/request/SetProcessVariablesRequest";
import CreateDocumentsRequest from "../../../service/request/CreateDocumentsRequest";
import GetMyActiveTaskRequest from "../../../service/request/GetMyActiveTaskRequest";
import TaskApi from "../../../service/TaskService";
import { mapActions } from "vuex";

export default {
  name: "video-conversation",
  components: {
    ...Components,
    ...JitsiComponents
  },
  beforeMount: function() {
    if(this.isEmpty(this.$route.query.processId)) {
      this.processId = this.$store.getters["processId"];
      this.roomName = this.$route.params.roomName;
      this.tckn = this.$route.params.tckn;
      this.leadPartyId = this.$route.params.leadPartyId;
      this.primaryContactType = this.$route.params.primaryContactType;
    } else {
      this.processId = this.$route.query.processId;
      this.retrieveTask().then(response => {
        if (
          response &&
          response.activeResourceTask &&
          response.activeResourceTask.processVariables
        ) {
          this.tckn = response.activeResourceTask.processVariables.find(x => x.code == "leadTCKN").value;
          this.leadPartyId = response.activeResourceTask.processVariables.find(x => x.code == "leadId").value;
          this.primaryContactType = response.activeResourceTask.processVariables.find(x => x.code == "leadPrimaryContactType").value;
          this.roomName = this.generateUniqueRoomName(this.processId);
        }
      });   
    }
    this.renderJitsi = true;
    this.screenShotLoading(false);
    this.retrieveCheckListItems();
  },
  data() {
    return {
      task: {
        activeResourceTask: {

        }
      },
      renderJitsi: false,
      customerCard: {
        identityValue: 12345678901,
        name: "Eylem Yılmaz",
        motherName: "Ayşe Yılmaz",
        fatherName: "Ali Yılmaz",
        birthPlace: "Bakırköy / İstanbul",
        birthDate: "01/01/2020",
        gender: "KADIN",
        nationality: "TC",
        taxStatus: "-",
        profession: "Tasarımcı",
        address: "Lorem ipsum dolor sit amet, consectetur",
        email: "customer@softtech.com.tr",
        phoneNumber: "(555) 444 33 22"
      },
      showCustomerCard: true,
      screenshotLoaded: 0,
      capturedScreenshots: [],
      showAddScreenshotDialog: false,
      screenshotToAdd: undefined,
      showUploadSuccess: false,
      screenshotLoading: false,
      faceRecStatus: 0,
      faceRecStatusTemp:0,
      faceRecValue: 0,
      leadPhoto: "",
      nfcPhoto: "",
      imagesUploaded: false,
      imagesUploading: false,
      addressApproved: false,
      isProcessAvailableForFaceRecognition: false,
      isVideoOtpEnabled: false,
      userCardCreate: false,
      allProvisionList: [],
      checkListItems: [],
      selected: [],
      isContractListEnabled: false,
      //basicListItems: [],
      contractInfoList: "",
      processVariablesList: [],
      allListItems:[],
      processId: "",
      roomName:"",
      processVariables:[],
      nfcStatus: false
    };
  },

  computed: {
    checkedScreenshots: function() {
      return this.capturedScreenshots.filter(screenshot => screenshot.checked);
    },
    screenshotPercentage: function() {
      if (this.checkedScreenshots.length > 0) {
        return Math.floor(
          100 * (this.screenshotLoaded / this.checkedScreenshots.length)
        );
      }
      return 0;
    }
  },

  methods: {
    ...mapActions(["screenShotLoading"]),
    onClickToggleCustomerCard() {
      this.showCustomerCard = !this.showCustomerCard;
    },
    onScreenshotCaptured(dataURL) {
      this.screenshotToAdd = dataURL;
      this.showAddScreenshotDialog = true;
    },
    showCustomerCardOpen() {
      this.userCardCreate = true;
    },
    async uploadScreenshots() {
      this.screenshotLoaded = 0;
      this.imagesUploading = true;
      this.screenShotLoading(true);

      const createDocumentsRequest = new CreateDocumentsRequest();

      for (const element of this.checkedScreenshots) {
        const b64Data = element.dataURL.substring(
          "data:image/png;base64,".length
        );
        const raw = window.atob(b64Data);
        const rawLength = raw.length;
        const byteArray = new Uint8Array(new ArrayBuffer(rawLength));
        for (var i = 0; i < rawLength; i++) {
          byteArray[i] = raw.charCodeAt(i);
        }

        createDocumentsRequest.documentFile.fileName =
          element.value + "_" + this.tckn + ".png";
        createDocumentsRequest.documentFile.file = [].slice.call(byteArray);
        createDocumentsRequest.documentFile.mimeType = "png";
        createDocumentsRequest.documentFile.size = parseInt(
          b64Data.replace(/=/g, "").length * 0.75
        );
        createDocumentsRequest.documentTypeCode = element.value;
        createDocumentsRequest.sourceType = "WEB_AGENT";
        createDocumentsRequest.sourceValue = this.processId;

        const document = await this.createDocument(createDocumentsRequest);
        if (document != null) {
          this.screenshotLoaded++;
        }
      }

      this.capturedScreenshots = this.capturedScreenshots.filter(
        screenshot => !screenshot.checked
      );
      this.screenshotLoaded = 0;
      this.showUploadSuccess = true;
      this.screenShotLoading(false);
      this.imagesUploaded = true;
      this.imagesUploading = false;
    },
    createDocument(request) {
      return new Promise(resolve => {
        DocumentApi.create(
          this,
          request,
          response => {
            resolve(response);
          },
          error => {
            console.log("document error - create");
            console.log(error);
            console.log("document error - create");
          }
        );
      });
    },
    onScreenshotAddCanceled() {
      this.faceRecStatusTemp = 0;
      this.closeAddScreenshotDialog();
    },
    setNfcStatusAction(nfcStatus) {
      this.nfcStatus = nfcStatus;
      console.log("Emit Nfc Status :" + nfcStatus);
    },
    onScreenshotAdded(dataURL, document) {
      this.closeAddScreenshotDialog();
      this.faceRecStatus = this.faceRecStatusTemp;
      this.capturedScreenshots.push({
        dataURL: dataURL,
        label: document.name,
        value: document.code,
        checked: false
      });
    },
    closeAddScreenshotDialog() {
      this.showAddScreenshotDialog = false;
      this.screenshotToAdd = null;
    },
    async calculateFaceRecognitionMatch() {
      this.faceRecStatusTemp = 1;
      const calculateFaceRecognitionRequest = new CalculateFaceRecognitionRequest();
      calculateFaceRecognitionRequest.nfcPhoto = this.$refs.tabholder.getUserImageData();
      calculateFaceRecognitionRequest.leadPhoto = this.screenshotToAdd;
      calculateFaceRecognitionRequest.identityNumber = this.tckn;
      calculateFaceRecognitionRequest.processId = this.processId;
      FaceRecognitionApi.calculate(
        this,
        calculateFaceRecognitionRequest,
        response => {
          this.faceRecStatusTemp = 2;
          this.faceRecValue = Math.floor(response.checkRatio);

          this.setFaceRecognitionRatioToProcess(this.faceRecValue);
        },
        error => {
          console.log(error);
          this.faceRecStatusTemp = 3;
           if (error.response == null 
            || error.response.data == null 
            || error.response.data.responseMessage == null 
            || error.response.data.responseMessage == '') {
              this.faceRecValue = 'System Exception. Please try again later';
          } else {
            this.faceRecValue = error.response.data.responseMessage;
          }
        }
      );
    },
    setFaceRecognitionRatioToProcess(faceRecValue) {
      const setProcessVariablesRequest = new SetProcessVariablesRequest();
      setProcessVariablesRequest.processId = this.processId;
      setProcessVariablesRequest.variableList = [
        {
          code: "faceRecognitionRatio",
          value: faceRecValue
        }
      ];

      ProcessVariableApi.setProcessVariables(this, setProcessVariablesRequest);
    },
    selectAllScreenshots() {
      const everyScreenshotChecked = this.capturedScreenshots.every(
        capturedScreenshot => capturedScreenshot.checked === true
      );
      if (everyScreenshotChecked) {
        this.capturedScreenshots.forEach(
          screenshot => (screenshot.checked = false)
        );
      } else {
        this.capturedScreenshots.forEach(
          screenshot => (screenshot.checked = true)
        );
      }
    },
    onCapturedScreenshotDeleted(item) {
      this.capturedScreenshots.splice(
        this.capturedScreenshots.indexOf(item),
        1
      );
      if (item.value === "OBAF") {
        this.faceRecStatus = 0;
        this.faceRecValue = 0;
        this.faceRecStatusTemp = 0;
      }
    },
    onAllCapturedScreenshotDeleted() {
      this.capturedScreenshots = [];
      this.faceRecStatus = 0;
      this.faceRecValue = 0;
      this.faceRecStatusTemp = 0;
    },
    setProcessAvailableForFaceRecognition(value) {
      this.isProcessAvailableForFaceRecognition = value;
    },
    setIsContractListEnabled(value) {
      this.isContractListEnabled = value;
    },
    setContractInfoList(value) {
      this.contractInfoList = value;
    },
    setProcessVariablesList(value) {
      this.processVariablesList = value;
    },
    setVideoOtpEnabled(value) {
      this.isVideoOtpEnabled = value;
    },
    retrieveCheckListItems(){
      VideoCallCompleteProvisionApi.getProvisionsByProcessId(
        this,
        this.processId, 
        response => {
          if (response && response.result) {
            this.allProvisionList = response.result; 
           this.allListItems = this.allProvisionList.filter(x => x.type == "CHECK_LIST");
            
           this.allListItems =  this.allListItems.sort((a,b) => a.id -b.id)
             
             
            for (const checkListItem of  this.allListItems ) {
                this.checkListItems.push(checkListItem.code);  
            }
            
          }
        },
        error => {
          console.log(error);
        }
      );
    },
    isEmpty(val){
      return (val === undefined || val == null || val.length <= 0) ? true : false;
  },
  retrieveTask() {
    return new Promise(resolve => {
      const getMyActiveTaskRequest = new GetMyActiveTaskRequest();
      getMyActiveTaskRequest.processId = this.processId;
      TaskApi.getMyActiveTask(
        this,
        getMyActiveTaskRequest,
        response => {
          resolve(response);
        },
        error => {
          console.log(error);
          resolve(null);
        }
      );
    });
  },
  generateUniqueRoomName(processId) {
    return `${
      this.$store.getters["user"].domainCode
    }-${processId}-${new Date().getTime()}`;
  }
  }
};


// WEBPACK FOOTER //
// ./src/pages/videoconversation/mixin/VideoConversation.js